import request from '@/utils/request'

// 获取看板列表
export function getViewList(data) {
  return request.post('/phalapi/public/?service=App.TrackV4.getViewList', data)
}

// 保存编辑看板
export function saveView(data) {
  return request.post('/phalapi/public/?service=App.TrackV4.saveView', data)
}

// 删除看板
export function deleteView(data) {
  return request.post('/phalapi/public/?service=App.TrackV4.deleteView', data)
}

// 获取看板下的图表
export function getViewAnalysisList(data) {
  return request.post('/phalapi/public/?service=App.TrackV4.getViewAnalysisList', data)
}

// 获取事件列表
export function getEventTree(data) {
  return request.post('/phalapi/public/?service=App.TrackV4.getEventTree', data)
}

// 保存图表
export function saveAnalysis(data) {
  return request.post('/phalapi/public/?service=App.TrackV4.saveAnalysis', data)
}

// 删除图表
export function deleteAnalysis(data) {
  return request.post('/phalapi/public/?service=App.TrackV4.deleteAnalysis', data)
}

// 获取图表信息
export function getAnalysisInfo(data) {
  return request.post('/phalapi/public/?service=App.TrackV4.getAnalysisInfo', data)
}

// 获取图表信息
export function getAnalysisChartDatas(data) {
  return request.post('/phalapi/public/?service=App.TrackV4.getAnalysisChartDatas', data)
}

// 获取图表信息
export function getKeyList(data) {
  return request.post('/phalapi/public/?service=App.TrackV4.GetKeyList', data)
}

// 获取图表信息
export function getValueList(data) {
  return request.post('/phalapi/public/?service=App.TrackV4.GetValueList', data)
}

// 获取图表信息
export function setKeyValueAliasName(data) {
  return request.post('/phalapi/public/?service=App.TrackV4.setKeyValueAliasName', data)
}
